<!--vueMiniPlayer-->
<template>
    <div class="qun-video">
        <vueMiniPlayer ref="video" :video="video" :mutex="true" @fullscreen="handleFullscreen" />
    </div>
</template>

<script>
    export default {
        props:{
            imgurl:{
                type:String,
                default:''
            },
            videourl:{
                type:String,
                default:''
            }
        },
        name: "",
        data(){
            return {
                video: {
                    url: this.videourl,
                    cover: this.imgurl,
                    muted: false,
                    loop: false,
                    preload: 'auto',
                    poster: '',
                    volume: 1,
                    autoplay: false
                }
            }
        },
        computed:{
            $video(){
                return this.$refs.video.$video
            }
        },
        methods:{
            handleFullscreen(){

            }
        }
    }
</script>

<style scoped>
.qun-video{
    max-width: 500px;
    width: 100%;
    min-width: 300px;
    height: 15em;
    margin: 0 auto;
}
</style>
